import { Font, StyleSheet } from '@react-pdf/renderer';
import RobotoRegular from '../../../assets/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../../assets/fonts/Roboto-Bold.ttf';

Font.register({
  family: 'Roboto',
  fonts: [{ src: RobotoRegular }, { src: RobotoBold, fontWeight: 700 }],
});

const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Roboto',
    paddingTop: 35,
    paddingBottom: 65,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: 20,
  },
  title: {
    alignSelf: 'center',
    fontWeight: 700,
    fontSize: 16,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  label: {
    fontWeight: 700,
    fontSize: 14,
  },
  value: {
    fontSize: 12,
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginHorizontal: 20,
    paddingHorizontal: 10,
    paddingVertical: 10,
    fontSize: 12,
    backgroundColor: '#222',
  },
  tableCellHeader: {
    color: '#fff',
  },
  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 10,
    fontSize: 12,
  },
  colorRow: {
    backgroundColor: '#cecece',
  },
  outcome: {
    color: '#ef3535',
  },
  totalContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  totalRow: {
    justifyContent: 'flex-start',
    paddingHorizontal: 10,
    paddingVertical: 5,
    fontSize: 10,
  },
  bar: {
    height: 1,
    backgroundColor: '#dedede',
    width: '100%',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

export default styles;
